import React, { useContext, useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { getDetallesPorIdQR } from "../../../API/RRHH/Secciones/SeccionesRequests";
import { Button } from "primereact/button";
import { TabView, TabPanel} from "primereact/tabview";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../Base/Components/Loader/Loader";
import { getDetallesPersonalPorIdQR } from "../../../API/RRHH/Personal/PersonalRequests";
import QRMarcajeCrud from "./QRMarcajeCrud";

const ListadoDetallesQR = ({openDialogDetalle, onHideDialogDetalle, idMarcajeQR}) => {
    const { userAuth } = useContext(AuthContext);
    const [loading, setLoading] = useState(false)
    const [secciones, setSecciones] = useState([]);
    const [personal, setPersonal] =  useState([]);
    const [visible, setVisible] = useState(false);

    const getInfoDet = async () =>{
        setLoading(true);
        const seccionesDet = await getDetallesPorIdQR(idMarcajeQR);
        setSecciones(seccionesDet);

        const personalDet =  await getDetallesPersonalPorIdQR(idMarcajeQR);
        setPersonal(personalDet);
        setLoading(false);
    }

    const columnsSecciones=[
        {
            header: 'ID',
            headerEn:'ID',
            field: 'IdMarcajeDetalle',
            className: 'XXsmall',
            alignFrozen: "left",
            frozen: "frozen",
            hidden:userAuth?.IdRol === 1
        },
        // {
        //     // FECHA CREADO
        //     field: "DateCreate",
        //     header: "Fecha Creado",
        //     className: "small",
        //     alignFrozen: "left",
        //     frozen: "frozen",
        //     Format: "Date",
        // },
        {
            // ESTADO
            field: "Estado",
            header: "Estado",
            className: "Xsmall",
            body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
            frozen: "frozen",
            alignFrozen: "left",
            Format: "Estado",
        },
        {
            header: 'Ids Secciones',
            headerEn:'Ids Section',
            field: 'IdSeccion',
            hidden:userAuth?.IdRol === 1
        },
        {
            header: 'Secciones',
            headerEn:'Sections',
            field: 'NombreSecciones',
            flex:1
        },
        {
            header: 'Usuario Creo',
            headerEn:'UserName',
            field: 'UserName',
        },
    ]

    const tableSecciones = {
        Columns: columnsSecciones,
        Data: secciones,
    };

    const columnsPersonal=[
        {
            header: 'ID',
            headerEn:'ID',
            field: 'IdMarcajeDetalle',
            className: 'XXsmall',
            alignFrozen: "left",
            frozen: "frozen",
            hidden:userAuth?.IdRol === 1
        },
        // {
        //     // FECHA CREADO
        //     field: "DateCreate",
        //     header: "Fecha Creado",
        //     className: "small",
        //     alignFrozen: "left",
        //     frozen: "frozen",
        //     Format: "Date",
        // },
        {
            // ESTADO
            field: "Estado",
            header: "Estado",
            className: "Xsmall",
            body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
            frozen: "frozen",
            alignFrozen: "left",
            Format: "Estado",
        },
        {
            header: 'Ids Personal',
            headerEn:'Ids Personal',
            field: 'IdPersonal',
            hidden:userAuth?.IdRol === 1
        },
        {
            header: 'Personal',
            headerEn:'Personal',
            field: 'NombrePersonal',
            flex:1,
            minWidth:500
        },
        {
            header: 'Usuario Creo',
            headerEn:'UserName',
            field: 'UserName',
        },
    ]

    const tablePersonal = {
        Columns: columnsPersonal,
        Data: personal,
    };

    useEffect(() =>{
        getInfoDet();
    },[idMarcajeQR])
    
  return (
    <Dialog
      visible={openDialogDetalle}
      onHide={onHideDialogDetalle}
      style={{ width: "65%", height: "70%" }}
    >
        <Loader loading={loading} querySelector={"#Modal"}/>
        <div id="Modal">
            <div style={{display: "flex", alignItems: "center",marginBottom: "1rem"}}>
                <h3 style={{ marginRight: "1rem" }}>Detalles</h3>
                <Button icon="pi pi-sync" onClick={() => getInfoDet()}/>
                <Button icon="pi pi-pencil" severity="success" className="mx-2" onClick={() => setVisible(true)}/>
            </div>

            <TabView>
                <TabPanel header="Secciones">
                <div
                    style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "1rem",
                    }}
                ></div>
                <div style={{ height: "50vh" }}>
                    <AgGrid table={tableSecciones} />
                </div>
                </TabPanel>
                
                <TabPanel header="Personal">
                <div
                    style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "1rem",
                    }}
                ></div>
                <div style={{ height: "50vh" }}>
                    <AgGrid table={tablePersonal} />
                </div>
                </TabPanel>
            </TabView>
        </div>

        <QRMarcajeCrud
        visible={visible}
        setVisible={setVisible}
        qrMarcajes={idMarcajeQR}
        getinfo={getInfoDet}/>
    </Dialog>
  );
};

export default ListadoDetallesQR;
